export const setConnectStatus = (connected) =>
	({
		type: 'SET_CONNECT_STATUS',
		payload: { connected }
	});

export const appJoinRequest = (user) =>
	({
		type: 'APP_JOIN_REQUEST',
		payload: { user }
	});

export const appLeaveRequest = (userId) =>
	({
		type: 'APP_LEAVE_REQUEST',
		payload: { userId }
	});

export const setDuplicatedStatus = (isDuplicated) =>
	({
		type: 'SET_DUPLICATED_STATUS',
		payload: { isDuplicated }
	});

export const setAppPlans = (plans) =>
	({
		type: 'SET_APP_PLANS',
		payload: { plans }
	});